import { AmberHoc, AmberHocProps } from '../../../util';
import {
  GetActivePileCableLinksDocument,
  GetActivePileCableLinksQuery,
  GetActivePileCableLinksQueryVariables,
  PileCableLinkFragmentFragment as Result,
  UnlinkPileCableMutationVariables as Variables,
  withUnlinkPileCable as HOC,
} from '../__generated';
import { GraphQLErrors } from './error';

export type WithUnlinkPileCableHocChildProps = {
  unlinkPileCable: (variables: Variables) => Promise<Result>;
};
export const withUnlinkPileCableHoc: AmberHoc<{}, WithUnlinkPileCableHocChildProps> = (component) =>
  HOC<
    AmberHocProps<{}, WithUnlinkPileCableHocChildProps, typeof component>,
    WithUnlinkPileCableHocChildProps
  >({
    options: { errorPolicy: 'all' },
    props: (props) => {
      const { mutate } = props;
      return {
        unlinkPileCable: async (variables) => {
          if (!mutate) {
            throw new Error('Unexpected error');
          }
          const result = await mutate({
            variables,
            update: (proxy, { data, errors: errors2 }) => {
              try {
                if (errors2 || !data) {
                  return;
                }
                const { unlinkPileCable: result } = data;
                const { pile_id } = result;
                const cached = proxy.readQuery<
                  GetActivePileCableLinksQuery,
                  GetActivePileCableLinksQueryVariables
                >({
                  query: GetActivePileCableLinksDocument,
                  variables: { pile_id },
                });
                if (!cached) {
                  return;
                }
                const { active_pile_cable_links } = cached;
                proxy.writeQuery<
                  GetActivePileCableLinksQuery,
                  GetActivePileCableLinksQueryVariables
                >({
                  query: GetActivePileCableLinksDocument,
                  data: {
                    __typename: 'Query',
                    active_pile_cable_links: [
                      ...active_pile_cable_links.filter(
                        (link) => link.cable_id !== result.cable_id
                      ),
                    ],
                  },
                  variables: { pile_id },
                });
              } catch (e) {
                // no-op
              }
            },
          });
          if (!result) {
            throw new Error('Unexpected response from server');
          }
          const { errors, data } = result;
          if (errors) {
            throw new GraphQLErrors(errors);
          }
          if (!data || !data.unlinkPileCable) {
            throw new Error('Unexpected response from server');
          }
          return data.unlinkPileCable;
        },
      };
    },
  })(component as any);
